import type { AnswersRequest } from '@webapp/survey/src/api/queries-api';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { QuestionSimpleApi } from './simple';

export class VoidQuestionApi extends QuestionSimpleApi {
    query(actor: QuestionActor): AnswersRequest {
        const { id } = actor.getSnapshot().context;
        return {
            question: id,
            data: [],
            comment: '',
        };
    }

    public validate(_: QuestionContext): boolean {
        return true;
    }
}
